import { createInstance, type i18n as I18n } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import mocki18n from 'tests/mocki18n';
import { getTQHostUrl } from 'utils/domains';

const setupI18n = () => {
  const i18n = createInstance();

  i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      load: 'all',
      backend: {
        loadPath: `${getTQHostUrl()}/locales/{{lng}}/translation.json`,
      },
      lng: 'en-US',
      fallbackLng: 'en-US',
      debug: true,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
    });

  return i18n;
};

const i18n: I18n = process.env.NODE_ENV === 'test' ? mocki18n : setupI18n();

export default i18n;
